/**
=========================================================
* Trust Cargo - loading skeletons
=========================================================
*/

// Soft UI Dashboard React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Soft UI Dashboard React helper functions
import rgba from "assets/theme/functions/rgba";

const { dark, grey } = colors;
const { borderRadius } = borders;

/**
 * The default MUI skeleton pulses grey on grey, which on a warm ivory page
 * looks like the screen has frozen. This one is tinted to the palette and
 * uses a travelling sheen instead of a pulse, so waiting reads as "loading"
 * rather than "broken".
 */
const skeleton = {
  styleOverrides: {
    root: {
      backgroundColor: rgba(dark.main, 0.06),
      borderRadius: borderRadius.sm,
      "&::after": {
        background: `linear-gradient(90deg, transparent, ${rgba(grey[100], 0.9)}, transparent)`,
      },
    },

    text: {
      borderRadius: borderRadius.sm,
      transform: "none",
      marginBottom: 6,
    },

    rectangular: {
      borderRadius: borderRadius.md,
    },

    // slower than the 1.5s default - a calmer rhythm reads as more considered
    wave: {
      "&::after": {
        animationDuration: "1.8s",
      },
    },
  },

  defaultProps: {
    animation: "wave",
  },
};

export default skeleton;
